<div class="add-remove-button" [ngClass]="{'align-right': alignRight}" (click)="$event.stopPropagation()">
  <button mat-button color="primary" class="input-button no-label small icon-button prefix-button" [disabled]="count <= 0 || applying"
          (click)="$event.stopPropagation(); removeCount()">
    <mat-icon class="svg-icon" [svgIcon]="'minus'"></mat-icon>
  </button>
  <mat-form-field #inputElement appearance="outline" class="tiny no-hint no-label small with-suffix with-prefix">
    <input matInput type="number" [(ngModel)]="count" [min]="0" [max]="max" [disabled]="!autoBind && max === 0"
           (keyup)="userAction = true"
           (click)="$event.stopPropagation()">
  </mat-form-field>
  <button mat-button color="primary" class="input-button no-label small icon-button suffix-button" [disabled]="(autoBind ? max === 0 : count >= max) || applying"
          (click)="$event.stopPropagation(); addCount()">
    <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
  </button>
</div>
<ng-container *ngIf="withHints">
  <mat-hint class="inline-hint text-warning" [ngClass]="{'align-right': alignRight}" *ngIf="count > max">
    <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
    {{ 'general.api_cart_tickets_max_amount_reached' | translate: {max} }}
  </mat-hint>
  <mat-hint class="inline-hint text-muted" [ngClass]="{'align-right': alignRight}" *ngIf="max === 0">
    <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
    {{ 'general.api_cart_tickets_limit_in_cart_exceeded' | translate }}
  </mat-hint>
</ng-container>
